export enum PersonValueFormat{
    Percent = 1,
    Absolute = 2
}